import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PokemonCard from '../components/PokemonCard';
import {Link} from "react-router-dom";
import {removeAll, removePokemon as removePokemonTeam1} from "../teams/Team1Slice";
import {toast, ToastContainer} from "react-toastify";

const Team1Page = () => {
    const pokemonNames = useSelector(state => state.team1.team);
    const [pokemonData, setPokemonData] = useState([]);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    const Han = () => {
        dispatch(removeAll())
            toast.success("all pokemos removed", {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",

            });


    }
    useEffect(() => {
        if (pokemonNames.length > 0) {
            setLoading(true);
            const fetchAllPokemon = async () => {
                try {
                    const promises = pokemonNames.map(name =>
                        fetch(`https://pokeapi.co/api/v2/pokemon/${name.toLowerCase()}`).then(res => res.json())
                    );
                    const results = await Promise.all(promises);
                    setPokemonData(results);
                } catch (error) {
                    console.error(error);
                    setPokemonData([]);
                } finally {
                    setLoading(false);
                }
            };
            fetchAllPokemon();
        } else {
            setPokemonData([]);
            setLoading(false);
        }
    }, [pokemonNames]);


    if (loading) return <div className="flex items-center justify-center min-h-screen">Načítám...</div>;

    return (
        <div><Link to={"/pokemons"}> <button className="bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition p-5 m-1 ">Vyhledavač
        </button></Link>
            <Link to={"/pokemons/team2"}><button className={"bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition p-5 m-1 "}>Team 2</button></Link>
            <button onClick={Han} className={"bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition p-5 m-1"}>Remove All</button>
            <div className="max-w-5xl mx-auto mt-8 p-6 bg-white rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold mb-6 text-center">Team 1</h1>
                <div className="flex flex-wrap gap-2 ">
                        {pokemonData.map(pokemon => (
                        <PokemonCard
                            key={pokemon.id}
                            name={pokemon.name}
                            src={pokemon.sprites.front_default}
                            color={pokemon.types}
                        />
                    ))}
                </div>
            </div>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                limit={1}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </div>
    );
};

export default Team1Page;
